import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import "../../common/form-input/form-input.component.css";
import {
  ResetPasswordFormValues,
  useResetPassword,
} from "./useResetPassword";
import { useStyles } from "./reset-password.styles";

const Alert: React.FC<AlertProps> = (props) => (
  <MuiAlert elevation={6} variant="filled" {...props} />
);

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { onSubmit, snack, closeSnack } = useResetPassword();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm<ResetPasswordFormValues>({ mode: "onChange" });

  const hasPasswordValue = !!watch("newPassword");

  return (
    <React.Fragment>
      <div className={classes.container}>
        <span className={classes.title}>{t("auth.setNewPassword")}</span>
        <form className={classes.card} onSubmit={handleSubmit(onSubmit)}>
          <div className="group">
            <input
              id="newPassword"
              type="password"
              autoComplete="new-password"
              className={`form-input h6-regular ${
                errors.newPassword ? "error" : ""
              }`}
              {...register("newPassword", {
                required: t("auth.passwordRequired") as string,
              })}
            />
            <label
              htmlFor="newPassword"
              className={`h6-regular form-input-label ${
                hasPasswordValue ? "shrink" : ""
              } ${errors.newPassword ? "error" : ""}`}
            >
              {t("auth.newPassword")}
            </label>
          </div>

          <button
            type="submit"
            className={classes.submitButton}
            disabled={!isValid}
          >
            {t("auth.reset")}
          </button>
        </form>
      </div>
      <Snackbar
        open={snack.open}
        autoHideDuration={1000}
        onClose={closeSnack}
        anchorOrigin={{
          vertical: "top",
          horizontal: t("css.snackBarPosition") as "left" | "right" | "center",
        }}
      >
        <Alert onClose={closeSnack} severity={snack.success ? "success" : "error"}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{snack.message}</span>
          </div>
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default ResetPassword;
